import type { Skill } from '../skillsData';

export const cryptoskillAnalyticsExtraBData: Skill[] = [
  {
    id: 'defillama-official-defillama-setup',
    name: 'defillama-official-defillama-setup',
    author: 'DefiLlama',
    authorHandle: '@defillama',
    tag: 'Skill',
    category: 'analytics',
    description: 'DefiLlama official setup analytics. Protocol onboarding metrics, initial liquidity tracking, and new protocol discovery tools.',
    downloads: 12400,
    stars: 620,
    version: '1.0.0',
    installCommand: '> install the defillama-official-defillama-setup skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/defillama-official-defillama-setup',
    usageExample: '> track protocol onboarding\n> monitor initial liquidity\n> discover new protocols',
    detailedDescription: 'DefiLlama official protocol setup and onboarding analytics. Track new protocol registration metrics, monitor initial liquidity flows, and discover emerging DeFi protocols before they gain mainstream attention.',
  },
  {
    id: 'defillama-official-flows-and-events',
    name: 'defillama-official-flows-and-events',
    author: 'DefiLlama',
    authorHandle: '@defillama',
    tag: 'Skill',
    category: 'analytics',
    description: 'DefiLlama official flows and events analytics. Capital flow tracking, major DeFi events, hack monitoring, and TVL movement alerts.',
    downloads: 18600,
    stars: 930,
    version: '1.0.0',
    installCommand: '> install the defillama-official-flows-and-events skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/defillama-official-flows-and-events',
    usageExample: '> track capital flows\n> monitor DeFi events\n> alert on TVL movement',
    detailedDescription: 'Official DefiLlama capital flows and events analytics. Track cross-protocol and cross-chain capital movements, monitor major DeFi events and exploits, and receive real-time TVL movement alerts.',
    trending: true,
  },
  {
    id: 'defillama-official-institutional-crypto',
    name: 'defillama-official-institutional-crypto',
    author: 'DefiLlama',
    authorHandle: '@defillama',
    tag: 'Skill',
    category: 'analytics',
    description: 'DefiLlama institutional crypto analytics. Institutional inflows, whale tracking, large transaction monitoring, and institutional-grade market intelligence.',
    downloads: 14200,
    stars: 710,
    version: '1.0.0',
    installCommand: '> install the defillama-official-institutional-crypto skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/defillama-official-institutional-crypto',
    usageExample: '> track institutional inflows\n> monitor whale activity\n> analyze large transactions',
    detailedDescription: 'DefiLlama institutional-grade crypto analytics. Monitor institutional capital inflows into DeFi, track whale wallet activity, analyze large transaction patterns, and generate institutional market intelligence reports.',
  },
  {
    id: 'defillama-official-market-analysis',
    name: 'defillama-official-market-analysis',
    author: 'DefiLlama',
    authorHandle: '@defillama',
    tag: 'Skill',
    category: 'analytics',
    description: 'DefiLlama official market analysis. Sector rotation analysis, market share evolution, competitive dynamics, and protocol performance benchmarking.',
    downloads: 22400,
    stars: 1120,
    version: '1.0.0',
    installCommand: '> install the defillama-official-market-analysis skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/defillama-official-market-analysis',
    usageExample: '> analyze sector rotation\n> track market share\n> benchmark protocol performance',
    detailedDescription: 'Official DefiLlama market analysis platform. Analyze DeFi sector rotations, track market share evolution over time, study competitive dynamics between protocols, and benchmark protocol performance against peers.',
    featured: true,
  },
  {
    id: 'defillama-official-protocol-deep-dive',
    name: 'defillama-official-protocol-deep-dive',
    author: 'DefiLlama',
    authorHandle: '@defillama',
    tag: 'Skill',
    category: 'analytics',
    description: 'DefiLlama protocol deep-dive analytics. Granular protocol metrics, user behavior analysis, revenue decomposition, and competitive positioning.',
    downloads: 19800,
    stars: 990,
    version: '1.0.0',
    installCommand: '> install the defillama-official-protocol-deep-dive skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/defillama-official-protocol-deep-dive',
    usageExample: '> deep dive protocol\n> analyze user behavior\n> decompose revenue',
    detailedDescription: 'DefiLlama granular protocol analytics for deep-dive research. Analyze detailed protocol metrics, study user retention and behavior patterns, decompose revenue streams, and evaluate competitive positioning.',
    featured: true,
  },
  {
    id: 'defillama-official-risk-assessment',
    name: 'defillama-official-risk-assessment',
    author: 'DefiLlama',
    authorHandle: '@defillama',
    tag: 'Skill',
    category: 'analytics',
    description: 'DefiLlama official risk assessment. Protocol risk scoring, smart contract risk metrics, liquidity risk analysis, and DeFi protocol safety rankings.',
    downloads: 18600,
    stars: 930,
    version: '1.0.0',
    installCommand: '> install the defillama-official-risk-assessment skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/defillama-official-risk-assessment',
    usageExample: '> assess protocol risk\n> analyze smart contract risk\n> check safety ranking',
    detailedDescription: 'Official DefiLlama risk assessment platform. Score DeFi protocols on multiple risk dimensions, analyze smart contract complexity and audit status, evaluate liquidity risks, and access protocol safety rankings.',
  },
  {
    id: 'defillama-official-token-research',
    name: 'defillama-official-token-research',
    author: 'DefiLlama',
    authorHandle: '@defillama',
    tag: 'Skill',
    category: 'analytics',
    description: 'DefiLlama official token research. Token unlock schedules, vesting analysis, inflation metrics, and tokenomics health scoring.',
    downloads: 21600,
    stars: 1080,
    version: '1.0.0',
    installCommand: '> install the defillama-official-token-research skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/defillama-official-token-research',
    usageExample: '> research token unlocks\n> analyze vesting\n> score tokenomics health',
    detailedDescription: 'DefiLlama token research and tokenomics analytics. Track token unlock schedules, analyze vesting structures, monitor inflation and emission rates, and generate comprehensive tokenomics health scores.',
    trending: true,
  },
  {
    id: 'defillama-official-yield-strategies',
    name: 'defillama-official-yield-strategies',
    author: 'DefiLlama',
    authorHandle: '@defillama',
    tag: 'Skill',
    category: 'analytics',
    description: 'DefiLlama official yield strategies. Curated yield farming strategies, risk-adjusted APY comparison, and optimal allocation recommendations.',
    downloads: 26400,
    stars: 1320,
    version: '1.0.0',
    installCommand: '> install the defillama-official-yield-strategies skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/defillama-official-yield-strategies',
    usageExample: '> explore yield strategies\n> compare risk-adjusted APY\n> get allocation recommendation',
    detailedDescription: 'Official DefiLlama yield strategy analytics. Access curated yield farming strategies, compare risk-adjusted APYs across protocols, and receive optimal capital allocation recommendations based on risk appetite.',
    featured: true,
    trending: true,
  },
  {
    id: 'defillama-prices-api',
    name: 'defillama-prices-api',
    author: 'DefiLlama',
    authorHandle: '@defillama',
    tag: 'Skill',
    category: 'analytics',
    description: 'DefiLlama prices API. Real-time and historical token prices, cross-chain price comparison, and price deviation alerts across 200+ chains.',
    downloads: 35600,
    stars: 1780,
    version: '1.0.0',
    installCommand: '> install the defillama-prices-api skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/defillama-prices-api',
    usageExample: '> get token prices\n> compare cross-chain prices\n> set price deviation alert',
    detailedDescription: 'DefiLlama prices API integration. Access real-time and historical token prices across 200+ chains, compare prices for arbitrage opportunities, and receive alerts for significant price deviations between DEXes.',
    featured: true,
  },
  {
    id: 'defillama-yield-agent',
    name: 'defillama-yield-agent',
    author: 'DefiLlama',
    authorHandle: '@defillama',
    tag: 'Skill',
    category: 'analytics',
    description: 'DefiLlama yield agent. Conversational yield analytics, natural language yield queries, and automated yield opportunity discovery.',
    downloads: 14200,
    stars: 710,
    version: '1.0.0',
    installCommand: '> install the defillama-yield-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/defillama-yield-agent',
    usageExample: '> ask about yields\n> discover opportunities\n> query in natural language',
    detailedDescription: 'DefiLlama conversational yield analytics agent. Ask natural language questions about yield opportunities, discover new farming pools automatically, and receive plain-language yield comparison summaries.',
  },
  {
    id: 'defillama-yield-aggregator',
    name: 'defillama-yield-aggregator',
    author: 'DefiLlama',
    authorHandle: '@defillama',
    tag: 'Skill',
    category: 'analytics',
    description: 'DefiLlama yield aggregator analytics. Aggregator TVL tracking, protocol routing efficiency, and yield aggregator comparison across all major platforms.',
    downloads: 16800,
    stars: 840,
    version: '1.0.0',
    installCommand: '> install the defillama-yield-aggregator skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/defillama-yield-aggregator',
    usageExample: '> track aggregator TVL\n> analyze routing efficiency\n> compare yield aggregators',
    detailedDescription: 'DefiLlama yield aggregator analytics platform. Track TVL across all major yield aggregators, analyze protocol routing efficiency and fee structures, and compare aggregator performance metrics side-by-side.',
  },
  {
    id: 'defillama-yield-recommender',
    name: 'defillama-yield-recommender',
    author: 'DefiLlama',
    authorHandle: '@defillama',
    tag: 'Skill',
    category: 'analytics',
    description: 'DefiLlama yield recommender. Personalized yield recommendations, risk-profile based suggestions, and automated yield portfolio optimization.',
    downloads: 11200,
    stars: 560,
    version: '1.0.0',
    installCommand: '> install the defillama-yield-recommender skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/defillama-yield-recommender',
    usageExample: '> get personalized recommendation\n> set risk profile\n> optimize yield portfolio',
    detailedDescription: 'DefiLlama intelligent yield recommendation engine. Receive personalized yield farming suggestions based on risk tolerance, investment horizon, and asset preferences with automated portfolio optimization.',
  },
  {
    id: 'defillama-yield-scanner',
    name: 'defillama-yield-scanner',
    author: 'DefiLlama',
    authorHandle: '@defillama',
    tag: 'Skill',
    category: 'analytics',
    description: 'DefiLlama yield scanner. Real-time yield opportunity scanning, new pool detection, and APY change alerts across all tracked protocols.',
    downloads: 15600,
    stars: 780,
    version: '1.0.0',
    installCommand: '> install the defillama-yield-scanner skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/defillama-yield-scanner',
    usageExample: '> scan yield opportunities\n> detect new pools\n> alert on APY changes',
    detailedDescription: 'DefiLlama real-time yield scanning tool. Continuously scan for new yield opportunities, detect newly launched liquidity pools, and receive instant alerts when APYs change significantly.',
    trending: true,
  },
  {
    id: 'defillama-yield-tools',
    name: 'defillama-yield-tools',
    author: 'DefiLlama',
    authorHandle: '@defillama',
    tag: 'Skill',
    category: 'analytics',
    description: 'DefiLlama yield toolkit. Impermanent loss calculator, APY/APR converters, yield compounding simulator, and farming ROI projections.',
    downloads: 22400,
    stars: 1120,
    version: '1.0.0',
    installCommand: '> install the defillama-yield-tools skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/defillama-yield-tools',
    usageExample: '> calculate IL\n> convert APY to APR\n> simulate compounding',
    detailedDescription: 'Comprehensive DefiLlama yield toolkit with impermanent loss calculators, APY/APR conversion tools, yield compounding simulators, and detailed farming ROI projection models for informed DeFi decisions.',
    featured: true,
  },
  {
    id: 'defillama-yields-api',
    name: 'defillama-yields-api',
    author: 'DefiLlama',
    authorHandle: '@defillama',
    tag: 'Skill',
    category: 'analytics',
    description: 'DefiLlama yields API direct access. Programmatic yield data, pool metadata, and historical APY data for 10,000+ liquidity pools.',
    downloads: 28600,
    stars: 1430,
    version: '1.0.0',
    installCommand: '> install the defillama-yields-api skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/defillama-yields-api',
    usageExample: '> query yields API\n> get pool metadata\n> fetch historical APY',
    detailedDescription: 'Direct DefiLlama yields API integration. Programmatically access yield data for 10,000+ pools, retrieve detailed pool metadata, and analyze historical APY trends for informed liquidity provision decisions.',
    featured: true,
  },
  {
    id: 'defillama-yields',
    name: 'defillama-yields',
    author: 'DefiLlama',
    authorHandle: '@defillama',
    tag: 'Skill',
    category: 'analytics',
    description: 'DefiLlama yields core. Base yield data aggregation, pool comparison tools, and yield trend analysis across all DeFi protocols.',
    downloads: 34200,
    stars: 1710,
    version: '1.0.0',
    installCommand: '> install the defillama-yields skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/defillama-yields',
    usageExample: '> aggregate yield data\n> compare pools\n> analyze yield trends',
    detailedDescription: 'DefiLlama core yield aggregation module. Access base yield data from all tracked protocols, compare liquidity pools side-by-side, and analyze historical yield trends for optimal farming decisions.',
    featured: true,
    trending: true,
  },
  {
    id: 'dexpaprika-dex-search',
    name: 'dexpaprika-dex-search',
    author: 'CoinPaprika',
    authorHandle: '@coinpaprika',
    tag: 'Skill',
    category: 'analytics',
    description: 'DexPaprika DEX search and discovery. New pair detection, trending pool alerts, and DEX-wide liquidity discovery across 30+ decentralized exchanges.',
    downloads: 12400,
    stars: 620,
    version: '1.0.0',
    installCommand: '> install the dexpaprika-dex-search skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/dexpaprika-dex-search',
    usageExample: '> search DEX pairs\n> detect new pools\n> discover trending liquidity',
    detailedDescription: 'DexPaprika decentralized exchange search and discovery platform. Detect newly created trading pairs across 30+ DEXes, receive trending pool alerts, and discover liquidity opportunities before they gain mainstream attention.',
    trending: true,
  },
  {
    id: 'dune-analytics-api',
    name: 'dune-analytics-api',
    author: 'Dune Analytics',
    authorHandle: '@dune',
    tag: 'Skill',
    category: 'analytics',
    description: 'Dune Analytics API core. Execute SQL queries, access decoded blockchain data, and retrieve query results for custom on-chain analysis.',
    downloads: 38400,
    stars: 1920,
    version: '1.0.0',
    installCommand: '> install the dune-analytics-api skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/dune-analytics-api',
    usageExample: '> execute SQL query\n> access decoded data\n> retrieve results',
    detailedDescription: 'Core Dune Analytics API integration. Execute custom SQL queries against decoded blockchain databases, access structured on-chain data across 20+ chains, and programmatically retrieve query results for analysis.',
    featured: true,
  },
  {
    id: 'dune-mcp',
    name: 'dune-mcp',
    author: 'Dune Analytics',
    authorHandle: '@dune',
    tag: 'Skill',
    category: 'analytics',
    description: 'Dune MCP server. Model Context Protocol interface for Dune Analytics data access, query execution, and dashboard retrieval for AI agents.',
    downloads: 18600,
    stars: 930,
    version: '1.0.0',
    installCommand: '> install the dune-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/dune-mcp',
    usageExample: '> query Dune via MCP\n> execute SQL\n> retrieve dashboard data',
    detailedDescription: 'Dune Analytics Model Context Protocol server. Access Dune data through standardized MCP interfaces, execute SQL queries, retrieve existing dashboard data, and integrate on-chain analytics directly into AI agent workflows.',
    trending: true,
  },
  {
    id: 'elfa-api',
    name: 'elfa-api',
    author: 'ELFA',
    authorHandle: '@elfa_ai',
    tag: 'Skill',
    category: 'analytics',
    description: 'ELFA API crypto analytics. AI-powered market intelligence, predictive analytics, and automated trading signal generation for crypto markets.',
    downloads: 9200,
    stars: 460,
    version: '1.0.0',
    installCommand: '> install the elfa-api skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/elfa-api',
    usageExample: '> get AI market intel\n> generate predictions\n> create trading signals',
    detailedDescription: 'ELFA AI-powered crypto analytics API. Access machine learning market intelligence, generate predictive price models, and create automated trading signals based on comprehensive on-chain and off-chain data fusion.',
  },
  {
    id: 'ethereum-transaction-analyzer',
    name: 'ethereum-transaction-analyzer',
    author: 'Tx Analyzer',
    authorHandle: '@txanalyzer',
    tag: 'Skill',
    category: 'analytics',
    description: 'Ethereum transaction deep analyzer. Transaction trace analysis, gas optimization insights, MEV impact assessment, and execution path visualization.',
    downloads: 15600,
    stars: 780,
    version: '1.0.0',
    installCommand: '> install the ethereum-transaction-analyzer skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/ethereum-transaction-analyzer',
    usageExample: '> analyze transaction trace\n> optimize gas usage\n> assess MEV impact',
    detailedDescription: 'Deep Ethereum transaction analysis tool. Trace complex transaction execution paths, receive gas optimization recommendations, assess MEV extraction impact, and visualize complete call graphs for any EVM transaction.',
    trending: true,
  },
  {
    id: 'etherscan',
    name: 'etherscan',
    author: 'Etherscan',
    authorHandle: '@etherscan',
    tag: 'Skill',
    category: 'analytics',
    description: 'Etherscan core explorer integration. Block and transaction lookup, address monitoring, and blockchain exploration for Ethereum mainnet and testnets.',
    downloads: 82400,
    stars: 4120,
    version: '2.0.0',
    installCommand: '> install the etherscan skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/etherscan',
    usageExample: '> lookup block\n> monitor address\n> explore blockchain',
    detailedDescription: 'Etherscan block explorer core integration. Look up blocks and transactions, monitor address activity with real-time alerts, explore smart contracts, and access comprehensive Ethereum blockchain data across mainnet and testnets.',
    featured: true,
  },
  {
    id: 'etherscan-mcp',
    name: 'etherscan-mcp',
    author: 'Etherscan',
    authorHandle: '@etherscan',
    tag: 'Skill',
    category: 'analytics',
    description: 'Etherscan MCP server. Model Context Protocol access to Etherscan explorer data, contract verification, and on-chain analytics for AI agents.',
    downloads: 12600,
    stars: 630,
    version: '1.0.0',
    installCommand: '> install the etherscan-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/etherscan-mcp',
    usageExample: '> query Etherscan via MCP\n> verify contract\n> get on-chain analytics',
    detailedDescription: 'Etherscan Model Context Protocol server. Access explorer data through standardized MCP interfaces, verify smart contracts, query on-chain analytics, and integrate Ethereum blockchain intelligence into AI agent operations.',
  },
  {
    id: 'fear-greed-mcp',
    name: 'fear-greed-mcp',
    author: 'Alternative.me',
    authorHandle: '@alternativeme',
    tag: 'Skill',
    category: 'analytics',
    description: 'Fear & Greed Index MCP server. Real-time market sentiment via Model Context Protocol, with historical data and automated trading signal integration.',
    downloads: 11200,
    stars: 560,
    version: '1.0.0',
    installCommand: '> install the fear-greed-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/fear-greed-mcp',
    usageExample: '> query F&G via MCP\n> get historical sentiment\n> generate trading signal',
    detailedDescription: 'Crypto Fear & Greed Index Model Context Protocol server. Access real-time market sentiment scores, retrieve historical sentiment data, and generate automated trading signals based on extreme fear and greed conditions.',
  },
  {
    id: 'github-ai-trending-feed',
    name: 'github-ai-trending-feed',
    author: 'GitHub AI',
    authorHandle: '@github_ai',
    tag: 'Skill',
    category: 'analytics',
    description: 'GitHub AI trending crypto feed. Track trending crypto repositories, developer activity metrics, and open-source project momentum for market intelligence.',
    downloads: 8600,
    stars: 430,
    version: '1.0.0',
    installCommand: '> install the github-ai-trending-feed skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/github-ai-trending-feed',
    usageExample: '> track trending repos\n> analyze dev activity\n> measure OSS momentum',
    detailedDescription: 'GitHub AI-powered crypto trending feed. Track trending cryptocurrency and blockchain repositories, analyze developer commit activity and contributor growth, and measure open-source project momentum as market intelligence signals.',
    trending: true,
  },
  {
    id: 'gully-research-agent',
    name: 'gully-research-agent',
    author: 'Gully Research',
    authorHandle: '@gullyresearch',
    tag: 'Skill',
    category: 'analytics',
    description: 'Gully Research autonomous agent. Protocol research automation, due diligence report generation, and fundamental analysis for crypto investments.',
    downloads: 6800,
    stars: 340,
    version: '1.0.0',
    installCommand: '> install the gully-research-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/gully-research-agent',
    usageExample: '> research protocol\n> generate due diligence\n> run fundamental analysis',
    detailedDescription: 'Gully Research autonomous research agent for crypto protocols. Automate due diligence processes, generate comprehensive research reports, and perform fundamental analysis including tokenomics, team evaluation, and technology assessment.',
  },
  {
    id: 'holy-agent',
    name: 'holy-agent',
    author: 'Holy Protocol',
    authorHandle: '@holyprotocol',
    tag: 'Skill',
    category: 'analytics',
    description: 'Holy Protocol analytics agent. Sacred finance analytics, staking ritual metrics, and community-driven protocol intelligence for specialized DeFi ecosystems.',
    downloads: 4200,
    stars: 210,
    version: '1.0.0',
    installCommand: '> install the holy-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/holy-agent',
    usageExample: '> analyze sacred finance\n> track staking rituals\n> get community intel',
    detailedDescription: 'Holy Protocol specialized analytics agent. Analyze unique DeFi ecosystem metrics, track community staking behaviors and participation rituals, and generate community-driven protocol intelligence for emerging specialized finance platforms.',
  },
  {
    id: 'luminaverse',
    name: 'luminaverse',
    author: 'Luminaverse',
    authorHandle: '@luminaverse',
    tag: 'Skill',
    category: 'analytics',
    description: 'Luminaverse metaverse analytics. Virtual world economics, NFT land valuation, and metaverse platform metrics for digital real estate intelligence.',
    downloads: 5600,
    stars: 280,
    version: '1.0.0',
    installCommand: '> install the luminaverse skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/luminaverse',
    usageExample: '> analyze metaverse economics\n> value NFT land\n> track platform metrics',
    detailedDescription: 'Luminaverse metaverse and virtual world analytics platform. Analyze virtual world economic metrics, perform NFT land and digital real estate valuation, and track platform user engagement and transaction volumes.',
  },
  {
    id: 'luminaverse-gamefi',
    name: 'luminaverse-gamefi',
    author: 'Luminaverse',
    authorHandle: '@luminaverse',
    tag: 'Skill',
    category: 'analytics',
    description: 'Luminaverse GameFi analytics. Play-to-earn economics, game token analysis, player retention metrics, and blockchain gaming market intelligence.',
    downloads: 4800,
    stars: 240,
    version: '1.0.0',
    installCommand: '> install the luminaverse-gamefi skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/luminaverse-gamefi',
    usageExample: '> analyze P2E economics\n> track game tokens\n> measure player retention',
    detailedDescription: 'Luminaverse GameFi analytics platform. Analyze play-to-earn token economics, track gaming token performance, measure player retention and engagement metrics, and generate blockchain gaming market intelligence reports.',
  },
  {
    id: 'muto-ai-market-analyst',
    name: 'muto-ai-market-analyst',
    author: 'Muto AI',
    authorHandle: '@mutoai',
    tag: 'Skill',
    category: 'analytics',
    description: 'Muto AI market analyst. AI-powered technical analysis, chart pattern recognition, and automated market commentary for crypto trading.',
    downloads: 7600,
    stars: 380,
    version: '1.0.0',
    installCommand: '> install the muto-ai-market-analyst skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/muto-ai-market-analyst',
    usageExample: '> run technical analysis\n> recognize chart patterns\n> generate market commentary',
    detailedDescription: 'Muto AI-powered market analysis platform. Execute advanced technical analysis, automatically recognize chart patterns with computer vision, and generate real-time market commentary and trading insights.',
    trending: true,
  },
  {
    id: 'nansen-defi-positions',
    name: 'nansen-defi-positions',
    author: 'Nansen',
    authorHandle: '@nansen_ai',
    tag: 'Skill',
    category: 'analytics',
    description: 'Nansen DeFi positions tracker. Monitor DeFi protocol exposure, LP positions, lending health factors, and yield farming allocations across wallets.',
    downloads: 18600,
    stars: 930,
    version: '2.0.0',
    installCommand: '> install the nansen-defi-positions skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/nansen-defi-positions',
    usageExample: '> track DeFi positions\n> monitor LP exposure\n> check lending health',
    detailedDescription: 'Nansen DeFi position intelligence. Track detailed DeFi protocol exposures, monitor liquidity provider positions and impermanent loss, check lending health factors, and analyze yield farming allocations across labeled wallets.',
    featured: true,
  },
  {
    id: 'nansen-fund-tracker',
    name: 'nansen-fund-tracker',
    author: 'Nansen',
    authorHandle: '@nansen_ai',
    tag: 'Skill',
    category: 'analytics',
    description: 'Nansen fund tracker. Institutional fund flow monitoring, VC wallet tracking, treasury management analysis, and investment round detection.',
    downloads: 22400,
    stars: 1120,
    version: '2.0.0',
    installCommand: '> install the nansen-fund-tracker skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/nansen-fund-tracker',
    usageExample: '> track fund flows\n> monitor VC wallets\n> detect investment rounds',
    detailedDescription: 'Nansen institutional fund tracking platform. Monitor VC and fund wallet flows, track treasury management strategies, detect new investment rounds and token unlocks, and analyze institutional positioning in real-time.',
    featured: true,
  },
  {
    id: 'nansen-perp-screener',
    name: 'nansen-perp-screener',
    author: 'Nansen',
    authorHandle: '@nansen_ai',
    tag: 'Skill',
    category: 'analytics',
    description: 'Nansen perpetual screener. Futures market analytics, funding rate arbitrage detection, open interest analysis, and liquidation zone mapping.',
    downloads: 14200,
    stars: 710,
    version: '2.0.0',
    installCommand: '> install the nansen-perp-screener skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/nansen-perp-screener',
    usageExample: '> screen perp markets\n> detect funding arb\n> map liquidation zones',
    detailedDescription: 'Nansen perpetual futures market screener. Analyze funding rate differentials for arbitrage opportunities, track open interest changes, map liquidation price zones, and screen perpetual markets by smart money activity.',
    trending: true,
  },
  {
    id: 'nansen-search',
    name: 'nansen-search',
    author: 'Nansen',
    authorHandle: '@nansen_ai',
    tag: 'Skill',
    category: 'analytics',
    description: 'Nansen search and discovery. Entity search, wallet labeling, transaction pathfinding, and on-chain relationship mapping across 300M+ addresses.',
    downloads: 24600,
    stars: 1230,
    version: '2.0.0',
    installCommand: '> install the nansen-search skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/nansen-search',
    usageExample: '> search entities\n> label wallets\n> map relationships',
    detailedDescription: 'Nansen comprehensive on-chain search platform. Search and identify blockchain entities, apply automatic wallet labeling across 300M+ addresses, find transaction paths between wallets, and map on-chain relationship networks.',
    featured: true,
  },
  {
    id: 'nansen-smart-alerts',
    name: 'nansen-smart-alerts',
    author: 'Nansen',
    authorHandle: '@nansen_ai',
    tag: 'Skill',
    category: 'analytics',
    description: 'Nansen smart alerts system. Customizable on-chain alerts for whale movements, token unlocks, protocol events, and smart money actions.',
    downloads: 16800,
    stars: 840,
    version: '2.0.0',
    installCommand: '> install the nansen-smart-alerts skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/nansen-smart-alerts',
    usageExample: '> set whale alert\n> monitor token unlocks\n> track smart money',
    detailedDescription: 'Nansen intelligent alert system. Create customizable on-chain alerts for whale wallet movements, token unlock and vesting events, significant protocol transactions, and real-time smart money action notifications.',
    trending: true,
  },
  {
    id: 'nansen-token-research',
    name: 'nansen-token-research',
    author: 'Nansen',
    authorHandle: '@nansen_ai',
    tag: 'Skill',
    category: 'analytics',
    description: 'Nansen token research platform. Token distribution analysis, unlock schedule tracking, holder quality scoring, and vesting event monitoring.',
    downloads: 19800,
    stars: 990,
    version: '2.0.0',
    installCommand: '> install the nansen-token-research skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/nansen-token-research',
    usageExample: '> analyze token distribution\n> track unlock schedules\n> score holder quality',
    detailedDescription: 'Nansen comprehensive token research platform. Analyze token distribution across holder categories, track vesting and unlock schedules, score holder quality based on behavior patterns, and monitor upcoming unlock events.',
    featured: true,
  },
  {
    id: 'octav-official-api',
    name: 'octav-official-api',
    author: 'Octav',
    authorHandle: '@octav',
    tag: 'Skill',
    category: 'analytics',
    description: 'Official Octav API. Portfolio tracking, DeFi position analytics, tax reporting data, and cross-chain balance aggregation for crypto portfolios.',
    downloads: 11200,
    stars: 560,
    version: '1.0.0',
    installCommand: '> install the octav-official-api skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/octav-official-api',
    usageExample: '> track portfolio\n> analyze DeFi positions\n> generate tax data',
    detailedDescription: 'Official Octav portfolio and analytics API. Track comprehensive crypto portfolios across chains, analyze DeFi position performance, generate tax reporting data, and aggregate cross-chain balances automatically.',
  },
  {
    id: 'octodamus-intelligence',
    name: 'octodamus-intelligence',
    author: 'Octodamus',
    authorHandle: '@octodamus',
    tag: 'Skill',
    category: 'analytics',
    description: 'Octodamus predictive intelligence. AI-powered market prediction, on-chain prophecy analytics, and trend forecasting for crypto markets.',
    downloads: 6200,
    stars: 310,
    version: '1.0.0',
    installCommand: '> install the octodamus-intelligence skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/octodamus-intelligence',
    usageExample: '> get AI predictions\n> analyze on-chain prophecy\n> forecast trends',
    detailedDescription: 'Octodamus AI-powered predictive market intelligence platform. Generate price and trend predictions from on-chain data patterns, analyze prophetic indicators, and forecast market movements using machine learning models.',
  },
  {
    id: 'octodamus-market-intelligence',
    name: 'octodamus-market-intelligence',
    author: 'Octodamus',
    authorHandle: '@octodamus',
    tag: 'Skill',
    category: 'analytics',
    description: 'Octodamus market intelligence suite. Comprehensive market analysis, sentiment correlation, whale behavior prediction, and macro trend identification.',
    downloads: 4800,
    stars: 240,
    version: '1.0.0',
    installCommand: '> install the octodamus-market-intelligence skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/octodamus-market-intelligence',
    usageExample: '> analyze market\n> correlate sentiment\n> predict whale behavior',
    detailedDescription: 'Octodamus comprehensive market intelligence suite. Perform deep market analysis, correlate price movements with sentiment indicators, predict whale wallet behaviors, and identify macro market trends before they materialize.',
  },
  {
    id: 'omniplay-agent',
    name: 'omniplay-agent',
    author: 'OmniPlay',
    authorHandle: '@omniplay',
    tag: 'Skill',
    category: 'analytics',
    description: 'OmniPlay omnichain analytics agent. Cross-chain portfolio analysis, multi-chain yield comparison, and unified DeFi position tracking.',
    downloads: 7200,
    stars: 360,
    version: '1.0.0',
    installCommand: '> install the omniplay-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/omniplay-agent',
    usageExample: '> analyze cross-chain portfolio\n> compare multi-chain yields\n> track unified positions',
    detailedDescription: 'OmniPlay omnichain analytics agent. Analyze portfolios across 50+ chains, compare yield opportunities across multiple networks simultaneously, and track unified DeFi positions in a single comprehensive dashboard.',
  },
  {
    id: 'onchain-data-lord',
    name: 'onchain-data-lord',
    author: 'OnChain Data Lord',
    authorHandle: '@onchaindatalord',
    tag: 'Skill',
    category: 'analytics',
    description: 'OnChain Data Lord analytics. Deep blockchain data extraction, custom on-chain metrics creation, and advanced Dune-style query building without SQL.',
    downloads: 8600,
    stars: 430,
    version: '1.0.0',
    installCommand: '> install the onchain-data-lord skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/onchain-data-lord',
    usageExample: '> extract blockchain data\n> create custom metrics\n> build queries without SQL',
    detailedDescription: 'OnChain Data Lord advanced blockchain analytics platform. Extract deep on-chain data with natural language queries, create custom metrics without writing SQL, and build comprehensive analytics dashboards for any blockchain.',
    trending: true,
  },
  {
    id: 'pemulungx',
    name: 'pemulungx',
    author: 'PemulungX',
    authorHandle: '@pemulungx',
    tag: 'Skill',
    category: 'analytics',
    description: 'PemulungX on-chain scavenger analytics. Dormant wallet detection, abandoned asset recovery analytics, and lost treasure hunting across blockchains.',
    downloads: 3800,
    stars: 190,
    version: '1.0.0',
    installCommand: '> install the pemulungx skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/pemulungx',
    usageExample: '> detect dormant wallets\n> find abandoned assets\n> hunt lost treasures',
    detailedDescription: 'PemulungX unique on-chain scavenger analytics platform. Detect long-dormant wallets with valuable holdings, analyze abandoned assets and NFTs, and hunt for lost crypto treasures across all major blockchain networks.',
  },
];